import { useQuery } from "react-query";
import SchemaService from "../api/services/SchemaService";

export const useGetBondBasicSchema = (queryKey: string) => {
  const { data, isLoading, refetch, isError, error } = useQuery(
    queryKey,
    async () => await SchemaService.getBondBasicSchema()
  );

  return {
    bondBasicSchema: data?.data?.schema,
    isBondBasicSchemaLoading: isLoading,
    bondBasicSchemaError: error,
    isBondBasicSchemaError: isError,
    fetchBondBasicSchema: refetch,
  };
};
